export default __webpack_public_path__ + "static/media/database.6960faf2.svg";